module.exports = __webpack_public_path__ + "static/media/CL36_SE.4e932990.jpg";